import React from "react";
import colors from "../../../utils/colors";
import { bg_auth, forerunnerIcon2 } from "../../../assets";

const Banner = () => {
  return (
    <div
      style={{
        backgroundImage: `url(${bg_auth})`,
        backgroundSize: "cover",
        position: "relative",
        backgroundPosition: "center",
        minHeight: "100vh",
      }}
      className="w-[50%] font-lato flex flex-1 flex-col justify-between p-[100px]"
    >
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          bottom: 0,
          width: "100%",
          backgroundColor: colors.transparentGreen,
          flex: 1,
        }}
      ></div>

      <div className="flex gap-2" style={{ color: colors.dark }}></div>

      <div className="flex flex-col items-center gap-[24px] z-[1]">
        <img src={forerunnerIcon2} />
        <div className="text-center font-lexend text-[40px] font-[600] leading-[50px] text-[white]">
          {`Welcome to Ubimed Medical Personnel Portal`}
        </div>
      </div>

      <div className="flex justify-center text-[20px] gap-5 font-lato leading-normal"></div>
    </div>
  );
};

export default Banner;
